import { useSelector, useDispatch } from "react-redux";
import { updateMarkComplimentartRoomsDrawerVisible } from "../../../../reducer/bookingReducer";
const ComplimentaryBookingsButton = ()=>{
    const {
        selectedRoomWTypeAndNum
    } = useSelector((store) => store.walkin);
    const dispatch = useDispatch();
    return (<div className=" rounded-md p-2 border-[1px] border-[#EDF1F7] text-[#007FFF] gap-[10px] items-center flex justify-between">
        <button className=" text-[0.875rem] font-[500]  text-[#007FFF] " onClick={()=>dispatch(updateMarkComplimentartRoomsDrawerVisible(true))}>
            Complimentary Rooms
        </button>
    </div>)
}
export default ComplimentaryBookingsButton;